import { get_token, get_user_profile } from "@/router";
import BolideAssistantButton from "@/components/BolideAssistantButton/BolideAssistantButton.vue";

export default {
  name: "HeaderSection",

  components: {
    BolideAssistantButton
  },

  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    },
    show_breadcrumb: {
      type: Boolean,
      default: true
    },
    show_parent_breadcrumb: {
      type: Boolean,
      default: true
    }
  },

  emits: [
    "breadcrumb-click",
    "open-assistant",
    "toggle-mobile-sidebar"
  ],

  data() {
    return ({
      is_mobile: window.innerWidth < 768
    });
  },

  mounted() {
    window.addEventListener("resize", this.handle_resize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handle_resize);
  },

  methods: {
    handle_resize() {
      this.is_mobile = window.innerWidth < 768;
    },

    openAssistant() {
      this.$emit("open-assistant");
    },

    async logoutUser() {
      const profile = get_user_profile();
      const VUE_APP_LOGOUT_URL = process.env.VUE_APP_LOGOUT_URL;
      const auth_token = get_token();

      const user_details = {
        user_id: profile.id
      };

      let payload = {
        method: "POST",
        headers: {
          Authorization: `Token ${auth_token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(user_details)
      };

      const response = await fetch(VUE_APP_LOGOUT_URL, payload);
      const raw = await response.text();
      let parsed;

      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        parsed = { status: null };
      }

      if (parsed.status === "success" || response.ok) {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push("/login");
      }
    }
  }
};
